module.exports = __webpack_public_path__ + "static/13-f367e77419070e31fda4edc850305c3a.png";